<template>
  <div class="step3">
    <a-result status="success" title="申请成功" sub-title="请及时支付款项">
      <template #extra>
        <a-button
          v-if="bank && ct.projects && ct.projects.status == 2 && ct.poundage > 0"
          type="primary"
          @click="gopay"
        >
          去付款
        </a-button>
        <a-button @click="back"> 返回 </a-button>
      </template>
    </a-result>
    <input id="input" style="opacity: 0; position: absolute" />
    <div class="desc-wrap" v-if="ct.projects && ct.projects.status == 2 && ct.poundage > 0">
      <a-descriptions
        :column="1"
        :labelStyle="{
          width: '200px',
          textAlign: 'right',
        }"
        title="付款信息"
      >
        <a-descriptionsItem label="项目名称">
          {{ ct.project }}
        </a-descriptionsItem>
        <a-descriptionsItem label="付款时间">
          <div class="text-red-500">请在 {{ ct.kbdate }} 前支付</div>
        </a-descriptionsItem>
        <a-descriptionsItem label="账户名称">
          <span>台州信吉融资担保有限公司</span>
          <a-icon type="copy" class="cursor-pointer" @click="copy(台州信吉融资担保有限公司)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="开户行">
          {{ setting.invoice_bank }}
          <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_bank)"
        /></a-descriptionsItem>
        <a-descriptionsItem label="开户行账号">
          {{ setting.invoice_bank_account }}
          <a-icon type="copy" class="cursor-pointer" @click="copy(setting.invoice_bank_account)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="开户行行号">
          {{ setting.bank_code
          }}<a-icon type="copy" class="cursor-pointer" @click="copy(setting.bank_code)" />
        </a-descriptionsItem>
        <a-descriptionsItem label="金额">
          <div class="text-red-500">
            {{ ct.poundage ? ct.poundage.toFixed(2) : '' }}({{
              convertCurrency(parseFloat(ct.poundage ? ct.poundage.toFixed(2) : ''))
            }})
            <a-icon
              type="copy"
              class="text-black cursor-pointer"
              @click="copy(ct.poundage ? ct.poundage.toFixed(2) : '')"
            />
          </div>
        </a-descriptionsItem>
        <a-descriptionsItem label="*汇款用途附言:">
          <span class="text-3xl font-bold text-red-500">{{ ct.code }}</span>
          <a-icon type="copy" class="mt-3 cursor-pointer" @click="copy(ct.code)" />
          /></a-descriptionsItem
        >
        <a-descriptionsItem label="操作">
          <a-button type="primary" @click="copy(copyall())">
            <a-icon type="copy" class="cursor-pointer" />
            复制全部
          </a-button>
        </a-descriptionsItem>
      </a-descriptions>
      <a-descriptions-item label="推荐码">{{
        ct.p_user_id > 0 ? ct.p_user_id : ''
      }}</a-descriptions-item>
      <div class="">
        <div class="text-base font-bold">温馨提示</div>
        <div
          >1．保函费汇款转账
          <span class="text-2xl font-bold text-red-500">用途或附言</span
          >内容，除序列号以外，请勿备注其他内容。</div
        >
        <div> 2．如果不是从基本户付款或者登记的基本户账号有误，因此造成的后果由贵公司负责。 </div>
        <!-- <div>
          3．如果一个小时或者更长时间未出函，请
          <a-upload
            :before-upload="beforeUpload"
            :customRequest="api"
            accept="image/jpeg,image/png"
            :show-upload-list="false"
          >
            <a disabled v-if="loading">上传中</a>
            <a v-else>{{ isUpload ? '重新上传打款凭证' : '上传打款凭证' }}</a>
          </a-upload>
          ，并联系客服人员。
        </div> -->
        <div> 3．为防止企业客户信息被泄露，预防措施必不可少，故项目信息开标后解密 </div>
        <div>
          4．因银行转账存在延迟的问题，请尽量在项目开标或保证金缴纳截至时间前2小时完成支付。
        </div>
      </div>
    </div>
    <div class="h-8"></div>
  </div>
</template>
<script>
  import { config } from '@/api/config';
  import { banks } from '@/api/bank';
  import bus from '@/utils/bus';
  import { convertCurrency } from '@/utils/transContent';
  export default {
    data() {
      return {
        setting: {},
        banklist: [],
        ct: {},
      };
    },
    async mounted() {
      this.banklist = (await banks({ current: -1 })).data || {};
      this.setting = (await config()) || {};
      bus.$on('tosetp2', (data) => {
        this.ct = data;
      });
    },
    computed: {
      bank() {
        if (this.ct.bankName) {
          return this.banklist.find((e) => {
            return this.ct.bankName.indexOf(e.name) >= 0;
          });
        } else {
          return null;
        }
      },
    },
    methods: {
      convertCurrency,
      back() {
        this.$router.push(`/admin/contract_detail/${this.ct.id}`);
      },
      gopay() {
        window.open(this.bank ? this.bank.link : '', 'target', '_blank');
      },
      copyall() {
        return `项目名称 : ${this.ct.project}
账户名称 : ${this.setting.invoice_title || '台州信吉融资担保有限公司'}
开户行账号 : ${this.setting.invoice_bank_account}
开户行 : ${this.setting.invoice_bank}
开户行行号 : ${this.setting.bank_code}
金额 : ¥ ${this.ct.poundage}(${convertCurrency(parseFloat(this.ct.poundage.toFixed(2)))})
汇款用途附言 : ${this.ct.code}`;
      },
      copy(str) {
        const input = document.getElementById('input');
        input.value = str;
        input.focus();
        if (input.setSelectionRange) {
          input.setSelectionRange(0, input.value.length);
          console.log(input.setSelectionRange(0, input.value.length));
        } else {
          input.select();
        }
        try {
          const result = document.execCommand('copy');
          if (result) {
            this.$message.success('复制成功');
          }
        } catch (e) {
          console.log(e);
          console.error('复制失败，请重试~');
        }
      },
    },
  };
</script>
<style lang="less" scoped>
  .step3 {
    width: 750px;
    margin: 0 auto;
  }
  .desc-wrap {
    padding: 24px 40px;
    margin-top: 24px;
    background-color: #eeeeee;
  }
  .cursor-pointer {
    margin-left: 6px !important;
  }
  :deep(.ant-descriptions-item-label) {
    width: 200px !important;
    text-align: right;
    float: left;
  }
  :deep(.ant-descriptions-item-content) {
    float: right;
    width: 470px;
  }
</style>
